module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('affix', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.scrollSpy),
      expression: "scrollSpy"
    }],
    attrs: {
      "offset": 50
    }
  }, [_vm._c('ul', {
    staticClass: "nav bs-docs-sidenav",
    attrs: {
      "id": "sidenav"
    }
  }, _vm._l((_vm.sections), function(s) {
    return _vm._c('li', {
      class: {
        active: _vm.active == s.id
      }
    }, [_vm._c('a', {
      attrs: {
        "href": '#' + s.id
      }
    }, [_vm._v(_vm._s(s.name))])])
  })), _vm._v(" "), _vm._c('a', {
    staticClass: "back-to-top",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Back to top")]), _vm._v(" "), _vm._c('a', {
    staticClass: "back-to-top",
    attrs: {
      "href": "https://github.com/wffranco/vue-strap"
    }
  }, [_vm._v("GitHub")])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-91569a18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91569a18!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/affixSidebar.vue
// module id = 120
// module chunks = 0